// General error codes that can be used across different features
export const ERROR_CODES = Object.freeze({
  DUPLICATE_PHONE_DOB: {
    code: "DUPLICATE_PHONE_DOB",
    statusCode: 409,
    translationKey: "selfEnrollment.errors.duplicate_phone_dob"
  },
  MISSING_PHONE: {
    code: "MISSING_PHONE",
    statusCode: 400,
    translationKey: "selfEnrollment.errors.missing_phone"
  },
  MISSING_DOB: {
    code: "MISSING_DOB",
    statusCode: 400,
    translationKey: "selfEnrollment.errors.missing_dob"
  },
  DRUG_HAS_CLAIMS: {
    code: "DRUG_HAS_CLAIMS",
    statusCode: 409,
    translationKey: "patientApplications.medications_covered_cannot_remove_in_claims"
  }
});
